import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { RegistMarkFileVo } from "../vo/regist-mark-file.model";

/**
 * マークファイル登録サービス
 *
 * @export RegistMarkFileService
 * @class RegistMarkFileService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistMarkFileService extends PlessJsonResponderSub<any> {
  private vo: RegistMarkFileVo;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistMarkFileService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        Rec: {
          condition: {
            MarkCode: this.vo.markCode,
            MarkCodeBranch: this.vo.markCodeBranch,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistMarkFileService
   */
  execute(vo: RegistMarkFileVo, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registMarkFile', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistMarkFileService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
